<template>
  <div class="proxima--font">
    <v-row dense class="px-4">
      <v-col cols="12" class="d-flex">
        <h2 v-if="$route.name">{{ $route.name }}</h2>
        <v-spacer />
        <AdminOrderPrepCSVexportButton />
      </v-col>
    </v-row>
    <v-row dense class="px-4">
      <v-col cols="12" sm="6" :md="getEnableItemDates ? 6 : 12">
        <OrderPrepAvailabilityPicker />
      </v-col>
      <v-col cols="12" sm="6" md="6" v-if="getEnableItemDates">
        <OrderPrepDateControls />
      </v-col>
      <v-col cols="12">
        <transition name="fade" mode="out-in">
          <div v-if="!selectedFilter" class="py-5">
            <h3 class="proxima-medium--font text-center"
              >Select at least one Availability
              {{ getEnableItemDates ? 'or Date' : '' }} to view total quantities
              of Items ordered.</h3
            >
          </div>
          <v-data-table
            v-else
            :headers="headers"
            :loading="loading"
            :items="orderPrepItems"
            :items-per-page="1000"
            hide-default-footer
            show-expand
            :expanded.sync="expanded"
            item-key="item_name"
            class="mm-base-table"
            ref="table"
            height="calc(100vh - 230px)"
            v-bind="{ dense: true, fixedHeader: true, ...$attrs }"
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="pa-2 elevation-1">
                <v-data-table
                  dense
                  :items="item.orders"
                  :items-per-page="1000"
                  :headers="[
                    {
                      text: 'Last Name',
                      value: 'customer.last_name',
                    },
                    {
                      text: 'First Name',
                      value: 'customer.first_name',
                    },
                    {
                      text: 'Order',
                      value: 'ticket_number',
                    },
                    {
                      text: 'Quantity',
                      value: 'quantity',
                      width: 200,
                    },
                    {
                      text: 'Gift?',
                      value: 'is_gift',
                      width: 65,
                      align: 'center',
                    },
                  ]"
                  hide-default-footer
                >
                  <template v-slot:item.is_gift="{ item }">
                    <v-icon v-if="item.is_gift" small>mdi-gift-outline</v-icon>
                  </template>
                  <template v-slot:item.customer.first_name="{ item }">
                    <span v-if="item.is_gift">{{
                      JSON.parse(item.giftee_details).first_name
                    }}</span>
                    <span v-else>{{ item.customer.first_name }}</span>
                  </template>
                  <template v-slot:item.customer.last_name="{ item }">
                    <span v-if="item.is_gift">{{
                      JSON.parse(item.giftee_details).last_name
                    }}</span>
                    <span v-else>{{ item.customer.last_name }}</span>
                  </template>
                  <template v-slot:item.ticket_number="{ item }">
                    <v-btn
                      rounded
                      color="blue lighten-2 white--text"
                      depressed
                      x-small
                      :to="{ name: OrderEditRoute, params: { id: item.id } }"
                      >Order {{ item.ticket_number }}</v-btn
                    >
                  </template>
                </v-data-table>
              </td>
            </template>
            <template v-slot:no-data>
              No Orders Found. Please select another
              {{
                getEnableItemDates && orderPrepSearchDate
                  ? 'Date'
                  : 'Availability'
              }}.
            </template>
          </v-data-table>
        </transition>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
import _get from 'lodash/get'
import OrderModel from '@/models/OrderModel'

import RouteNames from '@/constants/RouteNames'
import OrderPrepAvailabilityPicker from '@/components/OrderPrepAvailabilityPicker'
import AdminOrderPrepCSVexportButton from '@/components/AdminOrderPrepCSVexportButton'
import OrderPrepDateControls from '@/components/OrderPrepDateControls'

export default {
  name: 'ManageOrderPrepTable',
  components: {
    OrderPrepAvailabilityPicker,
    AdminOrderPrepCSVexportButton,
    OrderPrepDateControls,
  },
  data() {
    return {
      orderPrepItems: [],
      error: null,
      loading: false,
      expanded: [],
      OrderEditRoute: RouteNames.Merchant.Manage.ORDERS,
      headers: [
        {
          text: 'Item Name',
          value: 'item_name',
          readonly: true,
        },
        {
          text: 'Quantity',
          value: 'total_quantity',
          readonly: true,
          width: 200,
        },
      ],
    }
  },
  computed: {
    ...mapFields('admin', [
      'prepAvailabilitySelections',
      'orderPrepSearchDate',
    ]),
    ...mapGetters('shop', ['getEnableItemDates']),

    selectedFilter() {
      return this.prepAvailabilitySelections.length || this.orderPrepSearchDate
    }, // selectedFilter
  },
  watch: {
    async prepAvailabilitySelections(prepAvailabilitySelections) {
      if (!prepAvailabilitySelections || !prepAvailabilitySelections.length) {
        return
      }
      this.orderPrepSearchDate = null
      this.loading = true
      try {
        const availabilityIds = prepAvailabilitySelections.map(
          (availabilityModel) => availabilityModel.$id
        )
        let orderPrepResponse = await OrderModel.fetchOrderPrepForAvailabilities(
          availabilityIds
        )
        this.orderPrepItems = _get(orderPrepResponse, 'response.data.data', [])
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    },
    async orderPrepSearchDate(searchDate) {
      if (!searchDate) {
        return
      }
      this.prepAvailabilitySelections = []
      this.loading = true
      try {
        let orderPrepResponse = await OrderModel.fetchOrderPrepByDate(
          searchDate
        )
        this.orderPrepItems = _get(orderPrepResponse, 'response.data.data', [])
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    },
  }, // watch
}
</script>
